export default __webpack_public_path__ + "static/media/roboto-v20-latin-italic.b1d9d990.woff";